let currentDate = null;
let selectedDate = null; // Store the currently selected date
var propsDate="";
// Main calendar function to render and initialize the calendar
export const calendar = (element, config, propDate) => {
  if (!currentDate) {  //Only set first time
    if (config.type === "appointment" && config.availability && config.availability.length > 0) {
      currentDate = parseDate(config.availability[0].start);
    } 
    else if (["fertility", "menopause"].includes(config.type) && config.cycleData && config.cycleData.currentCycle && config.cycleData.currentCycle.length > 0) {
      currentDate = parseDate(config.cycleData.currentCycle[0].start);
    }
    else if (["pregnancy", "andropause"].includes(config.type) && config.remainders && config.remainders.length > 0) {
      currentDate = parseDate(config.remainders[0]);
    }
    else {
      currentDate = new Date();
    }
  }

  element.innerHTML = ""; // Clear any previous content inside the element
  propsDate=propDate;
  // Create the main calendar structure
  const column6 = document.createElement("div");
  column6.className = "col-md-6";

  const calendarWrapper = document.createElement("section");
  calendarWrapper.className = "calendar-wrapper mx-auto  ms-lg-0";

  const calendarContainer = document.createElement("div");
  calendarContainer.className = "calendar";

  // Create header for month navigation
  const calendarHeader = document.createElement("div");
  calendarHeader.className = "calendar-header";

  const prevBtn = document.createElement("button");
  prevBtn.innerHTML = "<i class='bi bi-chevron-left'></i>";
  prevBtn.addEventListener("click", () => changeMonth(-1));

  const nextBtn = document.createElement("button");
  nextBtn.innerHTML = "<i class='bi bi-chevron-right'></i>";
  nextBtn.addEventListener("click", () => changeMonth(1));

  const monthLabel = document.createElement("span");
  monthLabel.className = "month-name";
 
  calendarHeader.appendChild(prevBtn);
  calendarHeader.appendChild(monthLabel);
  calendarHeader.appendChild(nextBtn);

  const calendarTable = document.createElement("table");
  const thead = document.createElement("thead");
  const headerRow = document.createElement("tr");

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  daysOfWeek.forEach((day) => {
    const th = document.createElement("th");
    th.textContent = day;
    th.className = day === "Sat" || day === "Sun" ? "weekend-day" : "";
    headerRow.appendChild(th);
  });

  thead.appendChild(headerRow);
  calendarTable.appendChild(thead);

  const tbody = document.createElement("tbody");
  calendarTable.appendChild(tbody);

  calendarContainer.appendChild(calendarHeader);
  calendarContainer.appendChild(calendarTable);
  calendarWrapper.appendChild(calendarContainer);
  element.appendChild(calendarWrapper);

  // Create the legends container
  const legendsWrapper = document.createElement("div");
  legendsWrapper.className = "fertility-tracker-legends-wrapper";

  const menstruationLegend = document.createElement("div");
  menstruationLegend.className = "legend-wrapper";
  menstruationLegend.innerHTML = `
    <div class="legend-mark legend-mark-menstruation"></div>
    <span>Menstruation</span>
  `;

  const ovulationLegend = document.createElement("div");
  ovulationLegend.className = "legend-wrapper";
  ovulationLegend.innerHTML = `
    <div class="legend-mark legend-mark-ovulation"></div>
    <span>Ovulation</span>
  `;

  legendsWrapper.appendChild(menstruationLegend);
  legendsWrapper.appendChild(ovulationLegend);
  calendarWrapper.appendChild(legendsWrapper);

      // Add the calendar note
      const calendarNote = document.createElement("div");
      calendarNote.className = "calendar-note";
      
      calendarNote.textContent =
        "Click on date above to add, edit, or view symptoms";
      calendarNote.style.display = config.type === "appointment" ? "none" : "block";
      calendarWrapper.appendChild(calendarNote);

  // Helper functions
  // Updated parseDate function to handle "MM/DD/YYYY" and "YYYY-MM-DD" formats
function parseDate(dateStr) {
  if (dateStr.includes("/")) {
    // Format is "MM/DD/YYYY"
    const [month, day, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  } else if (dateStr.includes("-")) {
    // Format is "YYYY-MM-DD"
    const [year, month, day] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  }
  return null;
}

// The dateMatches function will now use the updated parseDate function
function dateMatches(day, month, year, dateStr) {
  const targetDate = parseDate(dateStr);
  return (
    targetDate &&
    day === targetDate.getDate() &&
    month === targetDate.getMonth() &&
    year === targetDate.getFullYear()
  );
}


  function isWithinRange(day, month, year, start, end) {
    const currentDate = new Date(year, month, day);
    const startDate = parseDate(start);
    const endDate = end ? parseDate(end) : startDate;
    return currentDate >= startDate && currentDate <= endDate;
  }

  function renderCalendar() {
    tbody.innerHTML = "";
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    monthLabel.textContent = `${new Date(year, month).toLocaleString(
      "default",
      { month: "long" }
    )} ${year}`;

    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const today = new Date();

    let row = document.createElement("tr");
    for (let i = 0; i < firstDayOfMonth; i++) {
      row.appendChild(document.createElement("td"));
    }

    for (let day = 1; day <= daysInMonth; day++) {
      if (row.children.length === 7) {
        tbody.appendChild(row);
        row = document.createElement("tr");
      }

      const cell = document.createElement("td");
      cell.textContent = day;

      if (
        day === today.getDate() &&
        month === today.getMonth() &&
        year === today.getFullYear()
      ) {
        cell.classList.add("current-date");
      }

      if (config.availability) {
        config.availability.forEach(({ start }) => {
          const availabilityDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          // if (
          //   day === availabilityDate.getDate() &&
          //   month === availabilityDate.getMonth() &&
          //   year === availabilityDate.getFullYear()
          // )
          if (start === availabilityDate)
           {
            cell.classList.add("available");
          }
        });
      }

      // if (config.cycleData && config.cycleData.menstruation) {
      //   config.cycleData.menstruation.forEach(({ start, end }) => {
      //     if (isWithinRange(day, month, year, start, end)) {
      //       if (dateMatches(day, month, year, start)) {
      //         cell.classList.add("mensuration-start");
      //       } else if (dateMatches(day, month, year, end)) {
      //         cell.classList.add("mensuration-end");
      //       } else {
      //         cell.classList.add("mensuration-range");
      //       }
      //     }
      //   });
      // }

      if (config.cycleData) {
        // Current Cycle
        if (config.cycleData.currentCycle) {
            config.cycleData.currentCycle.forEach(({ start, end }) => {
                if (isWithinRange(day, month, year, start, end)) {
                    if (dateMatches(day, month, year, start)) {
                        cell.classList.add("mensuration-start");
                    } else if (dateMatches(day, month, year, end)) {
                        cell.classList.add("mensuration-end");
                    } else {
                        cell.classList.add("mensuration-range");
                    }
                }
            });
        }
    
        // Next Cycle
        if (config.cycleData.nextCycle) {
            config.cycleData.nextCycle.forEach(({ start, end }) => {
                if (isWithinRange(day, month, year, start, end)) {
                    if (dateMatches(day, month, year, start)) {
                        cell.classList.add("mensuration-start");
                    } else if (dateMatches(day, month, year, end)) {
                        cell.classList.add("mensuration-end");
                    } else {
                        cell.classList.add("mensuration-range");
                    }
                }
            });
        }
    }

     // Monthly Cycle
     if (config.cycleData && config.cycleData.monthCycle) {
      config.cycleData.monthCycle.forEach(({ start, end }) => {
        if (isWithinRange(day, month, year, start, end)) {
          if (dateMatches(day, month, year, start)) {
            cell.classList.add("mensuration-start");
          } else if (dateMatches(day, month, year, end)) {
            cell.classList.add("mensuration-end");
          } else {
            cell.classList.add("mensuration-range");
          }
        }
      });
    }


      if (config.cycleData && config.cycleData.ovulation) {
        config.cycleData.ovulation.forEach(({ start, end }) => {
          if (isWithinRange(day, month, year, start, end)) {
            if (dateMatches(day, month, year, start)) {
              cell.classList.add("ovulation-start");
            } else if (dateMatches(day, month, year, end)) {
              cell.classList.add("ovulation-end");
            } else {
              cell.classList.add("ovulation-range");
            }
          }
        });
      }
      

      if (config.type === "appointment") {
        if (
          selectedDate && propsDate!=null &&
          day === selectedDate.getDate() &&
          month === selectedDate.getMonth() &&
          year === selectedDate.getFullYear()
        ) {
          cell.classList.add("selected-appointment-date");
        }
      } else {
        if (
          selectedDate && propsDate==null &&
          day === selectedDate.getDate() &&
          month === selectedDate.getMonth() &&
          year === selectedDate.getFullYear()
        ) {
          cell.classList.add("selected-date");
          cell.classList.remove("selected-appointment-date");
        }
      }

      // Check if there are any remainders or notes before adding dots
      const hasRemainder =
        config.remainders &&
        config.remainders.some((dateStr) => {
          const remainderDate = parseDate(dateStr);
          return (
            day === remainderDate.getDate() &&
            month === remainderDate.getMonth() &&
            year === remainderDate.getFullYear()
          );
        });

      const hasNote =
        config.notes &&
        config.notes.some((dateStr) => {
          const noteDate = parseDate(dateStr);
          return (
            day === noteDate.getDate() &&
            month === noteDate.getMonth() &&
            year === noteDate.getFullYear()
          );
        });

      // // Add dot for remainder if the date has a remainder
      if (hasRemainder) {
         if (!cell.querySelector(".remainder-dot")) 
         {
          const remainderDot = document.createElement("div");
          remainderDot.className = "remainder-dot";
          cell.appendChild(remainderDot);
         }
       
      }

      // Add dot for note if the date has a note
      if (hasNote) {
        if (!cell.querySelector(".remainder-dot")) 
        {
          const noteDot = document.createElement("div");
          noteDot.className = "remainder-dot";
          cell.appendChild(noteDot);
        }
      }
 // Add a single dot if either a remainder or note exists for this date
    // Add a single dot if there is a remainder, a note, or both
  // Check if either remainder or note exists for the date
if (hasRemainder || hasNote) {
  // If a dot hasn’t already been added, add it now
  if (!cell.querySelector(".remainder-dot")) {
    const dot = document.createElement("div");
    dot.className = "remainder-dot";
    cell.appendChild(dot);
  }
}
      cell.addEventListener("click", () => {
        selectedDate = new Date(year, month, day);
        config.onDateSelect && config.onDateSelect(selectedDate);
        renderCalendar();
      });

      row.appendChild(cell);
    }

    if (row.children.length) {
      tbody.appendChild(row);
    }

    // Show/hide the legends based on the config data
    menstruationLegend.style.display =
      config.cycleData && config.cycleData.currentCycle ? "" : "none";
    ovulationLegend.style.display =
      config.cycleData && config.cycleData.ovulation ? "" : "none";
      //  menstruationLegend.style.display =
      // config.cycleData && config.cycleData.menstruation ? "block" : "none";
  }

  function changeMonth(direction) {
    currentDate.setMonth(currentDate.getMonth() + direction);
    renderCalendar();
    
    // Set the date to the first of the current month for fetching data
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    
    // Call onMonthChange with the first day of the new month
    config.onMonthChange && config.onMonthChange(firstDayOfMonth);
  }
  renderCalendar();
};

// Bottom of file
export const resetCalendarGlobals = () => {
  currentDate = null;
  selectedDate = null;
  propsDate = "";
};

if (typeof window !== "undefined") {
  window.resetCalendarGlobals = resetCalendarGlobals;
}
